import { Component } from '@angular/core';

@Component({
  selector: 'crg-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
}
